import * as React from 'react';
import { Button, ButtonGroup, createStyles, withStyles } from '@material-ui/core';
import cn from 'classnames';
const styles = (theme) => createStyles({
    root: {},
    button: {
        '&:hover': {
            backgroundColor: theme.color.primary.main,
            color: theme.color.font.light,
        },
    },
    selectedButton: {
        backgroundColor: theme.color.primary.main,
        color: theme.color.font.light,
    },
});
const GroupedButtons = (props) => {
    const { classes, items, value, onChange, testId = 'GroupedButtons', size = 'small', autoDisableOnSelection = false, } = props;
    return (React.createElement(ButtonGroup, { "data-testid": testId, size: size, className: classes.root, "aria-label": "small outlined button group" }, items.map((item) => (React.createElement(Button, { "data-testid": `${testId}-button`, key: item.value, className: cn({ [classes.selectedButton]: item.value === value }), classes: { root: classes.button }, onClick: () => onChange && onChange(item.value === value ? undefined : item.value), disabled: item.disabled || (autoDisableOnSelection && !!value && value !== item.value) }, item.label)))));
};
export default withStyles(styles)(GroupedButtons);
//# sourceMappingURL=GroupedButtons.js.map